import { render, staticRenderFns } from "./VideoFullscreen.vue?vue&type=template&id=e45c1600&"
import script from "./VideoFullscreen.vue?vue&type=script&lang=js&"
export * from "./VideoFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoFullscreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports